import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "icon-close" }, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex items-center font-bold cursor-pointer" }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = { class: "ml-2 text-sm font-normal text-gray-500" }
const _hoisted_6 = ["checked", "disabled", "onChange"]
const _hoisted_7 = { class: "ml-2 text-sm text-gray-500" }
const _hoisted_8 = { class: "list-disc ml-5 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_outline_button, {
      type: "outline",
      role: "danger",
      onClick: _ctx.openModal
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('proposal.products.remove.button')), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.modalVisibility,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalVisibility) = $event)),
      "buttons-position": "right",
      "prevent-close": "true",
      "block-confirm": !_ctx.hasSelection,
      onConfirmClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showConfirm = true))
    }, {
      title: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.products.remove.title')), 1)
      ]),
      default: _withCtx(() => [
        (!_ctx.carriers.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('proposal.products.remove.empty')), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carriers, (carrier) => {
          return (_openBlock(), _createElementBlock("div", {
            key: carrier.supplierId,
            class: "mb-4"
          }, [
            _createElementVNode("label", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "mr-2 cursor-pointer",
                "onUpdate:modelValue": ($event: any) => ((_ctx.selectedCarriers[carrier.supplierId]) = $event)
              }, null, 8, _hoisted_4), [
                [_vModelCheckbox, _ctx.selectedCarriers[carrier.supplierId]]
              ]),
              _createTextVNode(" " + _toDisplayString(carrier.supplier) + " ", 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.carrierCounts(carrier)), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carrier.products, (product) => {
              return (_openBlock(), _createElementBlock("div", {
                key: product.key,
                class: "flex items-center ml-6 mt-2 cursor-pointer"
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "mr-2 cursor-pointer",
                  checked: _ctx.selectedCarriers[carrier.supplierId] || !!_ctx.selectedProducts[product.key],
                  disabled: _ctx.selectedCarriers[carrier.supplierId],
                  onChange: ($event: any) => (_ctx.toggleProduct(product.key, $event))
                }, null, 40, _hoisted_6),
                _createElementVNode("span", null, _toDisplayString(product.label), 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('proposal.products.remove.' + product.tab)), 1)
              ]))
            }), 128))
          ]))
        }), 128))
      ]),
      "confirm-button": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('proposal.products.remove.button')), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "block-confirm"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showConfirm,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showConfirm) = $event)),
      type: "warning",
      onConfirmClick: _ctx.handleRemove
    }, {
      title: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.products.remove.confirm_title')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('proposal.products.remove.confirm_content')), 1),
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.confirmationItems, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirmClick"])
  ], 64))
}